import {
  ExtraPermissionPersistedSchema,
  UserRole
} from '@thedealersconcierge/lib/codecs/tdc';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { z } from 'zod';

// We store this is one entity to make it easier to manage lifecycle
type CognitoAuthData = {
  type: 'cognito';
  userId: string;
};

export const isCognitoAuth = (v: unknown): v is CognitoAuthData => {
  if (typeof v !== 'object' || v === null) return false;
  return 'type' in v && v.type === 'cognito';
};

type BackendAuthToken = {
  jwt: string;
};

export const authStateAtom = atomWithStorage<
  CognitoAuthData | BackendAuthToken | null
>('authStateAtom', null, undefined, {
  // Ensure that we have the auth state on page init
  getOnInit: true
});

export const ActiveDealership = z.object({
  role: UserRole,
  extraPermissions: ExtraPermissionPersistedSchema.array(),

  dealershipId: z.string().uuid(),
  dealershipName: z.string(),

  // These are in fact mandatory, we will set them as such when the backend model has been updated to
  // realize that all dealerships have a group
  dealershipGroupId: z.string().uuid().nullish(),
  dealershipGroupName: z.string().nullish(),
  groupRole: UserRole.nullish()
});

export type ActiveDealership = z.TypeOf<typeof ActiveDealership>;

type DealershipData = {
  activeDealershipPerms: ActiveDealership;
};

export const dealershipAtom = atomWithStorage<DealershipData | null>(
  'dealershipAtom',
  null
);

/**
 * Whether the Concierge drawer is open. Lives at app scope (not inside the
 * shell's local state) so the page beneath can react to the reduced width —
 * e.g. the dashboard compacts its controls row so nothing slips under the
 * drawer. Transient UI state, so a plain atom (not persisted).
 */
export const conciergeOpenAtom = atom(false);
